import hasClass from "./has-class";

const bcCategoryNav = () => {
    const toggleEl = document.querySelector(".header-bottom");
    const menu =  document.querySelector(".menu-categories-container");
    const menuDropdown = document.querySelector(".navMobileToggle");
    toggleEl.addEventListener('click', () => {
        if (window.innerWidth <= 1080) {
            menu.classList.toggle("menu-open");
            menuDropdown.classList.toggle("mobile-menu-active");
        }
    });

    const resieCloseNav = () => {
        if (window.innerWidth > 1080 && hasClass(menu, "menu-open")) {
            menu.classList.remove("menu-open");
            menuDropdown.classList.remove("mobile-menu-active");
        }
    };
    window.addEventListener('resize', () => {
        resieCloseNav();
    }, true);
}

export default bcCategoryNav;